import { atom } from "jotai";

export const isSignedInAtom = atom<boolean>(false);
